import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../index.css";
interface rangePickerProps {
  className?: string;
  range: Date[];
  setRange: React.Dispatch<React.SetStateAction<Date | any>>;
  title?: string;
  name: string;
  id: string;
  maxDate?: Date;
  minDate?: Date;
  formData: any;
}

export const RangePicker: React.FC<rangePickerProps> = ({
  className,
  range,
  setRange,
  title,
  formData,
  name,
  id,
  maxDate,
  minDate
}) => {
  return (
    <div className={`${className} w-full`}>
      <label className="text-sm text-secondary" htmlFor="">
        {title}
      </label>
      <DatePicker
        maxDate={maxDate}
        name={name}
        id={id}
        dateFormat="yyyy/MM/d"
        className="appearance-none  relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-primary focus:border-primary focus:z-10 text-sm"
        placeholderText="select Date"
        selectsRange={true}
        startDate={range[0]}
        endDate={range[1]}
        onChange={update => {
          setRange({ ...formData, [name]: update });
        }}
      />
    </div>
  );
};
